import { render, staticRenderFns } from "./dlxhMembershipCard.vue?vue&type=template&id=1097b8c0&scoped=true&"
import script from "./dlxhMembershipCard.vue?vue&type=script&lang=js&"
export * from "./dlxhMembershipCard.vue?vue&type=script&lang=js&"
import style0 from "./dlxhMembershipCard.vue?vue&type=style&index=0&id=1097b8c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1097b8c0",
  null
  
)

export default component.exports